import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import GiftCardInfo from './GiftCardInfo';
import GiftCardAvailable from './GiftCardAvailable';

const GiftCardBalanceFooter = ({ ...props }) => {
  const { mobile, balance } = props;

  return (
    <Box display="flex" flexDirection={mobile ? 'column' : 'row'}>
      <GiftCardInfo
        mobile={mobile}
        cardStatus={balance?.estadoTarjeta || ''}
        initialAmount={balance?.montoInicial || ''}
        validity={balance?.fechaVcto || ''}
      />
      <GiftCardAvailable
        mobile={mobile}
        amountAvailable={balance?.montoDisponible || ''}
      />
    </Box>
  );
};

GiftCardBalanceFooter.propTypes = {
  mobile: PropTypes.bool,
  balance: PropTypes.object,
};

export default GiftCardBalanceFooter;
